import React, {FC, useEffect} from 'react';

import {pluralise} from '@optimaxdev/utils';
import {connect} from 'react-redux';

import {FeatureWithAnalytics} from 'components/feature';
import {EEC_ACCESSORIES_ARRAY_AVAILABLE_FROM_CART} from 'constants/analytics/events/eec';
import {sendAnalyticsForAccessoriesFromCart} from 'desktop/pages/checkout/store/sagas/paymentStep/paymentMethods/amazon/utils/sendAnalyticsButtonAuth';
import {ApplicationStoreType} from 'desktop/store';

import {AccessoryType, AccessoryWindowType} from '../../store/reducers/accessories/accessoriesType';
import {
    getCartAccessoriesInStock,
    getDisplayedCartAccessoriesSimple,
    getFirstSimpleAccessoriesByParentId,
} from '../../store/selectors';
import {NewCartAccessoriesList} from '../newCartAccessoriesList/newCartAccessoriesList';

import {NewCartAccessoriesRedesign} from './redesign/newCartAccessoriesRedesign';

import s from './newCartAccessories.scss';

export type PropsType = {
    accessories: Array<AccessoryWindowType>;
    firstAccessory?: AccessoryType;
    displayedSimpleAccessories: Array<AccessoryType>;
};

/**
 * Accessories block on cart
 */
export const NewCartAccessories: FC<PropsType> = ({
    accessories,
    displayedSimpleAccessories,
    firstAccessory,
}) => {
    const accessoriesCount = accessories.length;

    useEffect(() => {
        if (accessoriesCount) {
            sendAnalyticsForAccessoriesFromCart(
                displayedSimpleAccessories,
                accessories,
                EEC_ACCESSORIES_ARRAY_AVAILABLE_FROM_CART,
            );
        }
    }, [accessoriesCount]);

    if (!firstAccessory) return null;

    return (
        <div className={s.container}>
            <FeatureWithAnalytics
                fallback={
                    <>
                        <h2 className={s.title}>
                            Special offers for your cart{' '}
                            <span className={s.titleCount}>
                                ({accessoriesCount} {pluralise('item', accessoriesCount)})
                            </span>
                        </h2>

                        <div className={s.listContainer} data-test-name="accessories">
                            <NewCartAccessoriesList accessories={accessories} />
                        </div>
                    </>
                }
                flag="dCartAccessoriesGroups"
                isInteraction={false}
                platform="desktop"
            >
                <NewCartAccessoriesRedesign />
            </FeatureWithAnalytics>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    accessories: getCartAccessoriesInStock(state),
    displayedSimpleAccessories: getDisplayedCartAccessoriesSimple(state),
    firstAccessory: getFirstSimpleAccessoriesByParentId(state),
});

export const NewCartAccessoriesConnected = connect(mapStateToProps)(NewCartAccessories);
